import { useEffect } from 'react';
import usePathNavigate from '../lib/hook/usePathNavigate';
import { Box, Button, Flex, Image, VStack } from '@chakra-ui/react';
import ReactPlayer from 'react-player';

function Intro() {
  const { pathNavigate, backNavigate } = usePathNavigate();

  const onSubmit = () => {
    localStorage.setItem('isViewIntro', 'true');
    pathNavigate('/');
  };

  return (
    <Box w={'full'} h={'full'}>
      <VStack gap={0}>
        <Image
          src={
            'https://mintwk.edge.naverncp.com/mint-house/media/lowacare_intro_top.png'
          }
        />

        <ReactPlayer
          url="https://mintwk.edge.naverncp.com/mint-house/media/LOWA_LAUNDRY_Final_Ver3_mid.mp4"
          playing
          muted
          controls
          playsinline
          width={'100%'}
          height={'100%'}
        />
        <Image
          src={
            'https://mintwk.edge.naverncp.com/mint-house/media/lowacare_intro_bottom.png'
          }
        />
      </VStack>
      <Flex
        position={'fixed'}
        bottom={5}
        width={'full'}
        maxW={'768px'}
        minW={'320px'}
        alignContent={'center'}
        justifyContent={'center'}>
        <Button
          colorScheme={'black_button'}
          w="85%"
          h={'60px'}
          borderRadius={'base'}
          fontSize={'18px'}
          fontWeight="bold"
          onClick={onSubmit}>
          서비스 신청하기
        </Button>
      </Flex>
    </Box>
  );
}

export default Intro;
